import { Link } from "react-router-dom";
import { Page, PageHeader, SectionCard, ABOUT_IMG } from "@/components/Common";
import { SECTIONS } from "@/pages/Home";
import { BookOpen } from "lucide-react";

export function UrduAdabPage() {
  return (
    <Page>
      <PageHeader
        title="اردو ادب"
        subtitle="اردو شاعری و نثر کی پوری دنیا — کلاسیکی میراث سے معاصر تخلیق تک"
        crumbs={[{ label: "اردو ادب" }]}
      />
      <div className="bg-[#fdfbf7] border border-[#d4af37]/40 rounded-2xl p-6 sm:p-10 mb-10 shadow-[0_4px_20px_rgba(42,21,8,0.06)]">
        <p className="text-lg leading-[2.3] text-[#33200f] text-right">
          اردو ادب آٹھ صدیوں سے زائد روایت کا حامل ہے — دکنی شاعری سے لے کر دہلی و لکھنؤ کے کلاسیکی دور،
          اصلاحی تحریکوں، ترقی پسند ادب اور جدید تخلیق تک۔ ادب نامہ پر اردو ادب کے تمام اہم ابواب منظم
          شکل میں دستیاب ہیں: شعراء و ادباء کے مکمل تعارف، اصنافِ ادب کا فنی مطالعہ، تاریخِ ادب کے ادوار،
          تنقید و تحقیق کے مضامین اور UGC NET کی تیاری کا منظم مواد۔
        </p>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8">
        {SECTIONS.filter((s) => s.to !== "/urdu-adab").map((s) => (
          <SectionCard key={s.to} {...s} />
        ))}
      </div>
    </Page>
  );
}

export function AboutPage() {
  return (
    <Page>
      <PageHeader title="ادب نامہ کے بارے میں" crumbs={[{ label: "ادب نامہ کے بارے میں" }]} />
      <div className="grid md:grid-cols-3 gap-8 items-start">
        <img src={ABOUT_IMG} alt="ادب نامہ" className="rounded-2xl border border-[#c5a059]/50 w-full object-cover md:sticky md:top-32" />
        <div className="md:col-span-2 bg-[#fdfbf7] border border-[#d4af37]/40 rounded-2xl p-6 sm:p-10 space-y-5 shadow-[0_4px_20px_rgba(42,21,8,0.06)]">
          <p className="text-lg leading-[2.3] text-[#33200f] text-right">
            ادب نامہ اردو زبان و ادب کی فروغ اور علمی مواد کی آسان رسائی کے لیے ایک جامع ڈیجیٹل پلیٹ فارم ہے۔
            یہاں آپ کو کلاسیکی اور جدید اردو ادب، شعراء و ادباء، تنقید و تحقیق، آڈیو و ویڈیو مواد اور
            UGC NET اردو (Paper 1 & Paper 2) سے متعلق مستند اور منظم مواد دستیاب ہے۔
          </p>
          <h3 className="text-xl font-bold text-[#2a1508] leading-[2] flex items-center gap-2">
            <BookOpen size={20} className="text-[#c5a059]" /> ہمارا مقصد
          </h3>
          <p className="text-lg leading-[2.3] text-[#33200f] text-right">
            اردو ادب کی میراث کو طلبہ، محققین اور قارئین تک منظم، مستند اور جدید انداز میں پہنچانا —
            ہر صنف کا فن، ہر دور کی تاریخ اور ہر شاعر کا کلام ایک کلک کی دوری پر۔
          </p>
          <h3 className="text-xl font-bold text-[#2a1508] leading-[2]">اہم ابواب</h3>
          <ul className="text-lg leading-[2.3] text-[#33200f] text-right list-disc pr-6 space-y-1">
            <li>شعراء و ادباء — حیات، خدمات اور منتخب کلام</li>
            <li>اصنافِ ادب — غزل، نظم، قصیدہ، مثنوی، مرثیہ، افسانہ، ناول وغیرہ</li>
            <li>تاریخِ ادب — ابتدائی دور سے معاصر ادب تک</li>
            <li>تنقید و تحقیق — مضامین، مقالات اور ادبی مباحث</li>
            <li>UGC NET اردو — Paper 1 و Paper 2 کی منظم تیاری</li>
          </ul>
          <Link to="/ugc-net" data-testid="about-ugc-link" className="inline-block mt-2 px-7 py-2.5 rounded-full bg-[#2a1508] text-[#f5efe3] hover:bg-[#4a2b16] transition-colors">
            UGC NET تیاری شروع کریں
          </Link>
        </div>
      </div>
    </Page>
  );
}
